import { NgModule } from '@angular/core';
import { SearchMenuComponent } from './search-menu.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [SearchMenuComponent],
  exports: [SearchMenuComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    MatTooltipModule,
    TranslateModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    PipesModule,
  ],
})
export class SearchMenuModule {}
